<div class="header">
  <div class="header-title">
    <rt-badge color="ai" [text]="'app.common.ai' | translate" />
    <span>{{
      'tlc.positions.position_details_dialog.tabs.description.ai_generator.header_initial'
        | translate
    }}</span>
  </div>
</div>

@if (isLoading()) {
  <div class="content">
    <div class="loading-container">
      <rt-placeloader variant="ai-text" />
      <rt-placeloader variant="ai-text" />
      <rt-placeloader variant="ai-text" />
    </div>
  </div>
}
